import {NgModule} from '@angular/core';
import {IonicPageModule} from 'ionic-angular';
import {JackingMergeModalComponent} from './jacking-merge-modal.component';

@NgModule({
  declarations: [JackingMergeModalComponent],
  imports: [IonicPageModule.forChild(JackingMergeModalComponent)]
})
export class JackingMergeModalComponentModule {}



// WEBPACK FOOTER //
// ./src/pages/jacking-activities/v2/components/jacking-merge-modal/jacking-merge-modal.component.module.ts